import React from 'react';

const HazardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 18L18 18" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M10 12.353L10 6.70597" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M2 18L10 2" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M18 18L10 2" strokeWidth="1.8" strokeLinecap="round" />
    <ellipse cx="10.0002" cy="15.1765" rx="0.888889" ry="0.941176" fill="#818181" />
  </svg>
);

export default HazardIcon;
